import React from "react";
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST } from './../_getjson';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Row, Grid, Col, Panel } from "react-bootstrap";
import PopupArcode from "../PopUp/PopUpApcode";
import PopUpCsexpense from "./../PopUp/PopUpCsexpense";
import PopUpOther from "../PopUp/PopUpOther";
import PopUpOtherDB from "../PopUp/PopUpOther";
import { parseJwt } from "../parseJWT";
import PopUpReport from "../PopUp/_fromShow";
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import _popuplistreport from './../PopUp/PopUpSearchPspayment';
import axios from 'axios'
import Chackdocno from './../CustomFunction/Docno/GetDocno'
import ChackAp from './../CustomFunction/Csap/GetAp'
import CheckUser from './../CustomFunction/Csuser/GetUser'
import CheckBrabchname from './../CustomFunction/Branch/Checkname'
import CheckDepartmentname from './../CustomFunction/Department/Checkname'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import CheckTaxrate from './../CustomFunction/Docgroup/CheckTaxrate'
import SelectDatas from "./../PopUp/SelectData"
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import Topbar from "../Components/Customtopbar/Topbar";
import FullScreenDialogs from '../PopUp/FullScreendialogs/FullScreen'
import "./../PSARDeposit/csardeposit.css";
import Inputtax from './../PopUp/FullScreendialogs/Components/Inputtax';
import Moment from 'moment';
import Rechecked from './Components/Rechecked'
require("./../PSARDeposit/index.css");
const rowTable = 300;
const defaultcode = "0";
const listmenu = [["บันทึกใบกำกับภาษีหลายใบ", "Inputtax"]]

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.APCODE = React.createRef();
    this.APNAME = React.createRef();
    this.Groupdata_code = React.createRef();
    this.DOCGROUP = React.createRef();
    this.DOCNO = React.createRef();
    this.TAXNO = React.createRef();
    this.REMARK = React.createRef();
    this.USERCODE = React.createRef();
    this.USERNAME = React.createRef();
    this.DEPARTMENT = React.createRef();
    this.DEPARTMENTTH = React.createRef();
    this.SITECODE = React.createRef();
    this.Branch = React.createRef();
    this.SUMAMOUNT1 = React.createRef();
    this.TAXRATE = React.createRef();
    this.TAXAMOUNT = React.createRef();
    this.TOTALAMOUNT = React.createRef();
    this.SUMAMOUNT2 = React.createRef();
    this.DEBTAMOUNT = React.createRef();
    this.state = {
      SwitchPopupArcode: false,
      openFullScreenDialogs: false,
      tableData: [],
      Groupdata_txt: "",
      Department_txt: "",
      Branch_txt: "",
      openBackdrop: false,
      autoClose: 3600,
      color: "warning",
      messagealert: "",
      TAXTYPE: defaultcode,
      //บันทึกใบกำกับภาษีหลายใบ
      inputtax: [],
      Refundablerate: '',
      Refundablevalue: '',
      Taxrefund: '',
      Totaltax: 0,
      //รหัสเครดิต
      Creditcode: "",
      //ครบกำหนด
      DUEDATE: "",
      checkenableInput: [],
      PROJECT: "",
    };
  }

  Cal_Price = async () => {
    var SUMAMOUNT1 = 0; // รวมจำนวนเงิน
    var SUMAMOUNT2 = 0; // มูลค่ายกเว้น
    var TOTALAMOUNT = 0; //มูลค่ารวมภาษี
    var DEBTAMOUNT = 0; // รวมทั้งสิ้น
    var Taxrate = 0;
    if (this.TAXRATE.current.value) {
      Taxrate = Number(this.TAXRATE.current.value).toFixed(2);
    }
    this.TAXRATE.current.value = await Number(Taxrate).toFixed(2);
    // var TAXAMOUNT = SUMAMOUNT1 / ((Taxrate / 100) + 1);
    var TAXRATE = await Number(this.TAXRATE.current.value);
    //----------แยกเลือกประเภทการขาย-----------------
    var TAXTYPE = String(this.state.TAXTYPE);
    var CTaxamount = 0;
    for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].AMOUNT; i++) {
      if (this.state.tableData[i].BTN_T === "1") {
        if (TAXTYPE === "0") {
          SUMAMOUNT1 += Number(this.state.tableData[i].AMOUNT)
          CTaxamount = 100
          TOTALAMOUNT += Number(this.state.tableData[i].AMOUNT) + (TAXRATE * Number(this.state.tableData[i].AMOUNT) / CTaxamount)
          DEBTAMOUNT += Number(this.state.tableData[i].AMOUNT) + (TAXRATE * Number(this.state.tableData[i].AMOUNT) / CTaxamount)
        } else if (TAXTYPE === "1") {
          SUMAMOUNT1 += Number(this.state.tableData[i].AMOUNT)
          CTaxamount = await 100 + TAXRATE
          DEBTAMOUNT += Number(this.state.tableData[i].AMOUNT)
          TOTALAMOUNT += Number(this.state.tableData[i].AMOUNT)
        } else if (TAXTYPE === "2") {
          SUMAMOUNT1 += Number(this.state.tableData[i].AMOUNT)
          CTaxamount = await 100 + TAXRATE
          DEBTAMOUNT += Number(this.state.tableData[i].AMOUNT)
          TOTALAMOUNT += Number(this.state.tableData[i].AMOUNT)
        }
      } else {
        SUMAMOUNT2 += parseFloat(this.state.tableData[i].AMOUNT)
        DEBTAMOUNT += Number(this.state.tableData[i].AMOUNT)
      }
    }
    if (SUMAMOUNT1 !== 0 && TAXTYPE !== "2") {
      this.TAXAMOUNT.current.value = parseFloat(TAXRATE * SUMAMOUNT1 / CTaxamount).toFixed(2)
    } else {
      this.TAXAMOUNT.current.value = (0).toFixed(2)
    }
    //รวมจำนวนเงิน
    this.SUMAMOUNT1.current.value = parseFloat(SUMAMOUNT1).toFixed(2)
    //มูลค่ารวมภาษี
    this.TOTALAMOUNT.current.value = parseFloat(TOTALAMOUNT).toFixed(2)
    // มูลค่ายกเว้น 
    this.SUMAMOUNT2.current.value = parseFloat(SUMAMOUNT2).toFixed(2)
    //เงินรวมทั้งสิ้น
    this.DEBTAMOUNT.current.value = parseFloat(DEBTAMOUNT).toFixed(2);
    //ส่งไปหน้าจ่ายเงิน
    this.setState({ AmountPayable: this.DEBTAMOUNT.current.value });
  }
  setCWTAX = async () => {
    let row = this.state.tableData
    let TAXRATE = Number(this.TAXRATE.current.value);
    var TAXTYPE = String(this.state.TAXTYPE);
    for (let i = 0; i < row.length && row[i].EXPCODE; i++) {
      let SUMAMOUNT1 = Number(row[i].AMOUNT)
      let Percent = 100
      let DEBTAMOUNT = SUMAMOUNT1
      if (row[i].BTN_T === "1") {
        if (TAXTYPE === "0") {
          DEBTAMOUNT = await SUMAMOUNT1 - (TAXRATE * SUMAMOUNT1 / Percent)
        } else {
          Percent = 100 + TAXRATE
          DEBTAMOUNT = await SUMAMOUNT1 - (TAXRATE * SUMAMOUNT1 / Percent)
        }
      }
      row[i].EXTAMOUNT = Number(DEBTAMOUNT).toFixed(2)
      row[i].EXTBATHAMOUNT = Number(DEBTAMOUNT).toFixed(2)
      row[i].PAYBALANCE = Number(DEBTAMOUNT).toFixed(2)
    }
    this.setState({ tableData: row })
    // this.Cal_Price();
  }
  Cal_Price1 = (e) => {
    if (e.key === "Enter" && e.target.value !== "") {
      this.Cal_Price();
    }
  }
  async componentDidMount() {
    await this.setState({ checkenableInput: JSON.parse(localStorage.getItem('checkoftxt')) })
    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
    this.setState({ USERCODE: SITECODESTR.User.CODE, });
    this.onAddValue("USERCODE", SITECODESTR.User.CODE)
    this.onAddValue("Branch", SITECODESTR.User.SITECODE);
    this.setRow(rowTable);
  }
  setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = { C0: i + 1 }
    }
    this.setState({ tableData: data });
  };
  SelectSetData = async (type, data, rowIndex) => {
    switch (type) {
      case "PriceType":
        this.setState({ TAXTYPE: await String(data) })
        this.Cal_Price();
        this.setCWTAX()
        break;
      case "Calendar":
        this.setState({ DUEDATE: data })
        break;
      case "Calendar1":
        this.setState({ DOCDATE: data })
        break;
      case "CALCWTAX":
        this.setState({ CALCWTAX: data })
        break;
      case "PROJECT":
        //textproject
        if (rowIndex === "") {
          this.setState({ PROJECT: data })
          //settableproject
          for (let i = 0; i < this.state.tableData.length; i++) {
            if (this.state.tableData[i].EXPCODE) {
              this.state.tableData[i].PROJECT = data
            }
          }
        }
        // tableproject
        if (rowIndex !== "") {
          this.state.tableData[Number(rowIndex)].PROJECT = data
        }
        break;
      default:
        break;
    }
  }
  SetPopup = (data) => {
    this.setState({ PopUpTYpe: data });
    this.setState({ openFullScreenDialogs: true })
    this.setState({ typeFullScreenDialogs: "showPopupOT" })
    this.setState({ titleFullScreenDialogs: "ค้นหารายการ" })
  }
  SetPopup1 = (data) => {
    this.setState({ PopUpTYpe: data });
    // this.setState({ showPopupDB: !this.state.showPopupDB });
    if (data === "Department") {
      // this.setState({ OtPopupType: type });
      this.setState({ typeFullScreenDialogs: "Departmenttb" })
      this.setState({ openFullScreenDialogs: true })
      this.setState({ titleFullScreenDialogs: "เลือกรายการ-csdepartment" })
    }
    if (data === "Branch") {
      // this.setState({ OtPopupType: type });
      this.setState({ typeFullScreenDialogs: "Branchtb" })
      this.setState({ openFullScreenDialogs: true })
      this.setState({ titleFullScreenDialogs: "เลือกรายการ-cssite" })
    }
  };
  Switch_PopupArcode = (e) => {
    this.setState({ openFullScreenDialogs: e })
    this.setState({ typeFullScreenDialogs: "SwitchPopupArcode" })
    this.setState({ titleFullScreenDialogs: "ค้นหาเจ้าหนี้-ตัวแทนจำหน่าย/AP" })
  };
  Switch_OtherPopup = type => {
    if (type === "Groupdataall") {
      this.setState({ OtPopupType: type });
      this.setState({ typeFullScreenDialogs: type })
      this.setState({ openFullScreenDialogs: true })
      this.setState({ titleFullScreenDialogs: "เลือกรายการ-csdocgroup" })
    }
    if (type === "Department") {
      this.setState({ OtPopupType: type });
      this.setState({ typeFullScreenDialogs: type })
      this.setState({ openFullScreenDialogs: true })
      this.setState({ titleFullScreenDialogs: "เลือกรายการ-csdepartment" })
    }
    if (type === "Branch") {
      this.setState({ OtPopupType: type });
      this.setState({ typeFullScreenDialogs: type })
      this.setState({ openFullScreenDialogs: true })
      this.setState({ titleFullScreenDialogs: "เลือกรายการ-cssite" })
    }
  }
  Get_PopUparcode = (APCODE, APNAME, Creditcode, TAXTYPE) => {
    this.CloseDialogs(false)
    // this.setState({ openFullScreenDialogs: false })
    this.APCODE.current.value = APCODE;
    this.APNAME.current.value = APNAME;
    this.setState({ TAXTYPE: String(TAXTYPE) })
    this.setState({ Creditcode: [Creditcode] })
    this.setState({ CALCWTAX: ["0"] })
  }
  Get_PopUpOther = async (val) => {
    this.CloseDialogs(false)
    var data = val.split("|");
    for (var i = 0; i < data.length; i++) {
      data[i] = data[i].trim();
    }
    switch (this.state.OtPopupType) {
      case "Groupdataall":
        this.Groupdata_code.current.value = data[0]
        this.DOCGROUP.current.value = data[1]
        this.setState({ Groupdata_txt: data[1] });
        await Chackdocno(data[0], "CSAPOTHERDEBT").then(async (result1) => {
          if (result1 !== undefined) {
            this.DOCNO.current.value = await result1
          } else {
            this.DOCNO.current.value = ""
          }
        }).finally(_ => {
          CheckTaxrate(data[0], "CSAPOTHERDEBT").then(async (result) => {
            this.TAXRATE.current.value = await result
            this.Cal_Price()
            this.setCWTAX()
          })


        }).catch((err) => {
          this.DOCNO.current.value = ""
          console.log(err);
        });
        break;
      case "Department":
        this.DEPARTMENT.current.value = await data[0];
        this.DEPARTMENTTH.current.value = await data[1];
        this.setState({ Department_txt: data[1] });
        break;
      case "Branch":
        this.SITECODE.current.value = await data[0];
        this.Branch.current.value = await data[1];
        this.setState({ Branch_txt: data[1] });
        break;
      default:
        break;
    }
  }
  GetPopUpCsexpense = async (data0) => {
    this.CloseDialogs(false)
    // this.setState({ openFullScreenDialogs: false })
    var col = this.state.tableData
    var data = [];
    var j = this.state.tableData.length
    var Department = ""
    var Department_Code = ""
    if (this.DEPARTMENT.current.value) {
      Department = this.DEPARTMENTTH.current.value
      Department_Code = this.DEPARTMENT.current.value
    }
    var SITECODE = ""
    var SITECODETH = ""
    if (this.SITECODE.current.value) {
      SITECODE = this.SITECODE.current.value
      SITECODETH = this.Branch.current.value
    }
    for (var i = 0; i < data0.length; i++) {
      data[j] = {
        C0: j + 1,
        EXPCODE: data0[i].code,
        EXPNAME: data0[i].text,
        REMARK: "",
        AMOUNT: (0).toFixed(2),
        DEPARTMENT_TH: Department,
        DEPARTMENT: Department_Code,
        SITECODE_TH: SITECODETH,
        SITECODE: SITECODE,
        BTN_T: data0[i].CALCTAX,
        WTAXRATE: data0[i].WTAXRATE,
        PROJECT: this.state.PROJECT,
      }
      await col.push(data[j])
      j++
    }
    const result = [];
    const map = new Map();
    for (const item of col) {
      // if (!map.has(item.EXPCODE)) {
      map.set(item.EXPCODE, true)  // set any value to Map
      if (item.EXPCODE) {
        result.push({
          C0: "",
          EXPCODE: item.EXPCODE,
          EXPNAME: item.EXPNAME,
          REMARK: item.REMARK,
          AMOUNT: item.AMOUNT,
          DEPARTMENT_TH: item.DEPARTMENT_TH,
          DEPARTMENT: item.DEPARTMENT,
          SITECODE_TH: item.SITECODE_TH,
          SITECODE: item.SITECODE,
          BTN_T: item.BTN_T,
          WTAXRATE: item.WTAXRATE,
          PROJECT: item.PROJECT,
        })
      }
      // }
    }
    var table = []
    for (let i = 0; i < result.length + 15; i++) {
      if (i < result.length) {
        table[i] = await {
          C0: i + 1,
          EXPCODE: result[i].EXPCODE,
          EXPNAME: result[i].EXPNAME,
          REMARK: result[i].REMARK,
          AMOUNT: result[i].AMOUNT,
          DEPARTMENT_TH: result[i].DEPARTMENT_TH,
          DEPARTMENT: result[i].DEPARTMENT,
          SITECODE_TH: result[i].SITECODE_TH,
          SITECODE: result[i].SITECODE,
          BTN_T: String(result[i].BTN_T),
          WTAXRATE: result[i].WTAXRATE,
          PROJECT: result[i].PROJECT,
        }
      } else {
        table[i] = {
          C0: i + 1,
        }
      }
    }
    this.setState({ tableData: table })
  };
  Get_PopUpDB = (data) => {
    this.CloseDialogs(false)
    var split_data = data.split("|");
    switch (this.state.PopUpTYpe) {
      case "Department":
        let arrData2 = this.state.tableData;
        arrData2[this.state.rowChk_wtb].DEPARTMENT = split_data[0]
        arrData2[this.state.rowChk_wtb].DEPARTMENT_TH = split_data[1]
        this.setState({ tableData: arrData2 });
        break;
      case "Branch":
        let arrData3 = this.state.tableData;
        arrData3[this.state.rowChk_wtb].SITECODE = split_data[0]
        arrData3[this.state.rowChk_wtb].SITECODE_TH = split_data[1];
        this.setState({ tableData: arrData3 });
        break;
      default: break;
    }
  }
  PopUpOtherClose = () => {
    this.setState({ showPopupOT: !this.state.showPopupOT });
  };
  PopUpOtherClose1 = () => {
    this.setState({ showPopupDB: !this.state.showPopupDB })
  };
  _cellButton(cell, row, enumObject, rowIndex) {
    var BTN = this.state.tableData[rowIndex].BTN_EXPCODE;
    var btnShow = "";
    switch (BTN) {
      case 1:
        btnShow = (
          <div style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.SetPopup.bind(null, "T_Expcode")}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = <i className=""></i>;
        break;
    }
    return <div>{btnShow}</div>;
  }
  _cellButton2(cell, row, enumObject, rowIndex) {
    var BTN = this.state.tableData[rowIndex].BTN_Department;
    var btnShow = "";
    switch (BTN) {
      case 1:
        btnShow = (
          <div style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.SetPopup1.bind(null, "Department")}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = <i className=""></i>;
        break;
    }
    return <div>{btnShow}</div>;
  }
  _cellButton3(cell, row, enumObject, rowIndex) {
    var BTN = this.state.tableData[rowIndex].BTN_Sitecode;
    var btnShow = "";
    switch (BTN) {
      case 1:
        btnShow = (
          <div style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.SetPopup1.bind(null, "Branch")}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = <i className=""></i>;
        break;
    }
    return <div>{btnShow}</div>;
  }
  cellcheckbok = (cell, row, enumObject, rowIndex) => {
    var BTN = this.state.tableData[rowIndex].BTN_T;
    var btnShow;
    switch (BTN) {
      case "0":
        btnShow = (
          <span>
            <i className="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")} style={{ paddingTop: "7px" }}></i>
          </span>
        );
        break;
      case "1":
        btnShow = (
          <span>
            <i className="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")} style={{ paddingTop: "7px" }}></i>
          </span>
        );
        break;
      default:
        btnShow = (
          <span>
            <i className=""> </i>
          </span>
        );
    }
    return <div>{btnShow}</div>;
  };
  Update_Status = async (Row, Status) => {
    var dataArray = this.state.tableData;
    dataArray[Row].BTN_T = await Status;
    this.setState({ tableData: await dataArray });
    //
    this.setCWTAX()
    this.Cal_Price()
  };
  onClickDocNo = async () => {
    if (!this.Groupdata_code.current.value) {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "รหัสกลุ่มข้อมูลไม่ถูกต้อง" })

    }
    if (this.Groupdata_code.current.value) {
      var url = "CSMAXDOC/MAXDOC?tablename=CSAPOTHERDEBT&code=" + this.Groupdata_code.current.value.trim();
      console.log(genURL(url));
      await axios.get(genURL(url), { timeout: 3600 }).then(res => {
        if (res.data.maxdoc.length > 0) {
          this.DOCNO.current.value = res.data.maxdoc;
        } else {
          this.DOCNO.current.value = "";
        }
      }).catch(error => {
        console.log(error);
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
        this.setState({ openBackdrop: false })
      });
    } else {
      this.DOCNO.current.value = "";
    }
  };
  onRowClick = (row, col, id) => {
    let C_row = this.state.tableData;
    this.setState({ cellValue: row.EXPCODE })
    // จำนวนเต็มเวลาคลิก
    let AMOUNT = row.AMOUNT
    if (col === 5 && AMOUNT !== "" && AMOUNT !== undefined) {
      row.AMOUNT = Number(AMOUNT)
    }
    // คลิกแผนก
    if (col === 6) {
      this.setState({ Department_TH: C_row[id].DEPARTMENT_TH })
      C_row[id].DEPARTMENT_TH = C_row[id].DEPARTMENT;
    }
    // คลิกสาขา
    if (col === 9) {
      this.setState({ Branch_TH: C_row[id].SITECODE_TH })
      C_row[id].SITECODE_TH = C_row[id].SITECODE;
    }
    // หาจากล่างขึ้นบน
    var Pr = this.state.tableData
    for (let i = 0; i < this.state.tableData.length; i++) {
      Pr[i].BTN_EXPCODE = 2;
      Pr[i].BTN_Department = 2;
      Pr[i].BTN_Sitecode = 2;
    }
    this.setState({ tableData: Pr })
    var j = 0
    for (var i = this.state.tableData.length - 1; i >= 0; i--) {
      if (!this.state.tableData[i].EXPCODE) { j = i; }
    }

    if ((col === 1 && j === id) || (col === 1 && row.EXPCODE !== undefined && row.EXPCODE !== "")) {
      this.setState({ Colcode: true });
      row.BTN_EXPCODE = 1;
      row.BTN_Department = 2;
      row.BTN_Sitecode = 2;
    } else if (col === 6 && typeof row.EXPCODE !== "undefined" && row.EXPCODE !== "") {
      row.BTN_EXPCODE = 2;
      row.BTN_Department = 1;
      row.BTN_Sitecode = 2;
    } else if (col === 9 && typeof row.EXPCODE !== "undefined" && row.EXPCODE !== "") {
      row.BTN_EXPCODE = 2;
      row.BTN_Department = 2;
      row.BTN_Sitecode = 1;
    } else {
      this.setState({ Colcode: false })
      this.setState({ Colall: false });
    }
    if (row.EXPCODE !== "" && row.EXPCODE !== undefined) {
      this.setState({ Colall: true });
    }
    this.setState({ rowChk_wtb: row.C0 - 1 });
  }
  EnterAddDataC1 = (i, data) => {
    var split_data = data.split("|");
    var row = this.state.tableData;
    row[i].BTN_EXPCODE = 1;
    row[i].EXPCODE = split_data[0];
    row[i].EXPNAME = split_data[1];
    row[i].REMARK = "";
    // Auto แผนก
    if (this.DEPARTMENTTH.current.value !== "") {
      row[i].DEPARTMENT_TH = this.DEPARTMENTTH.current.value
      row[i].DEPARTMENT = this.DEPARTMENT.current.value
    } else {
      row[i].DEPARTMENT_TH = "";
      row[i].DEPARTMENT = "";
    }
    // Auto สาขา
    if (this.Branch.current.value !== "") {
      row[i].SITECODE_TH = this.Branch.current.value
      row[i].SITECODE = this.SITECODE.current.value
    } else {
      row[i].SITECODE_TH = "";
      row[i].SITECODE = "";
    }
    row[i].BTN_T = split_data[2];
    row[i].AMOUNT = 0.00.toFixed(2);
    this.setState({ tableData: row });
  };
  afterSaveCell = async (row, cellName, cellValue) => {
    let S_row = this.state.tableData;
    let i = row.C0 - 1;
    // ทศนิยม 2 ตำแหน่ง ปริมาณ  ลด
    let AMOUNT = row.AMOUNT;
    if (cellName === "AMOUNT" && AMOUNT !== "") {
      row.AMOUNT = parseFloat(AMOUNT).toFixed(2)
      if (Number(AMOUNT) > 0) {
        this.setCWTAX()
      }
    }
    var cellValue1 = this.state.cellValue
    if (cellName === "EXPCODE" && cellValue !== "" && cellValue1 !== cellValue) {
      //console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx");
      var url = "CSEXPENSEJOINCSINCOMETYPE/GETCODE?Code=" + cellValue + "&user="
      console.log(genURL(url));
      await axios.get(genURL(url), { timeout: 3600 }).then(async (res) => {
        if (res.data.length === 1) {
          var dataArray = [];
          for (let i = 0; i < res.data.length; i++) {
            dataArray[i] = await {
              code: res.data[i].CODE,
              text: res.data[i].MYNAMETH,
              WTAXRATE: res.data[i].WTAXRATE == null ? "" : res.data[i].WTAXRATE,
              CALCTAX: res.data[i].CALCTAX,
              CALCWTAX: res.data[i].CALCWTAX,

            }
          }
          row.EXPCODE = ""
          this.GetPopUpCsexpense(dataArray)
        } else {
          this.setState({ C_Expcode: "" });
        }
      }).catch(error => {
        console.log(error);
      });
    } else if (cellName === "EXPCODE" && cellValue === ""  /* && this.state.tableData[row.C0].EXPCODE === "" */) {
      setTimeout(() => {
        this.SetRowNull();
      }, 500);
    }
    if (cellName === "DEPARTMENT_TH" && cellValue !== "") {
      CheckDepartmentname(cellValue).then(async (result) => {
        if (result !== "") {
          row.DEPARTMENT = cellValue
          row.DEPARTMENT_TH = await result
          await this.reload();
        } else {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "ไม่พบข้อมูล" })
          row.DEPARTMENT = "";
          row.DEPARTMENT_TH = "";
        }
      }).catch(error => {
        row.DEPARTMENT = "";
        row.DEPARTMENT_TH = "";
        console.log(error);
      });
    }
    if (cellName === "SITECODE_TH" && cellValue !== "") {
      CheckBrabchname(cellValue).then(async (result) => {
        if (result !== "") {
          row.SITECODE = cellValue
          row.SITECODE_TH = await result
          await this.reload();
        } else {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "ไม่พบข้อมูล" })
          row.SITECODE = "";
          row.SITECODE_TH = "";
        }
      }).catch(error => {
        row.SITECODE = "";
        row.SITECODE_TH = "";
        console.log(error);
      });
    }

    // ลบแผนก
    if (cellName === "DEPARTMENT_TH" && cellValue === "") {
      S_row[i].DEPARTMENT = "";
      this.setState({ tableData: S_row });
    }
    // ลบสาขา
    if (cellName === "SITECODE_TH" && cellValue === "") {
      S_row[i].SITECODE = "";
      this.setState({ tableData: S_row });
    }
    if (cellName === "AMOUNT" && cellValue !== "") {
      setTimeout(() => {
        this.Cal_Price();
      }, 30);
    }
  };
  reload = () => {
    var data = this.state.tableData
    this.setState({ tableData: data })
  }
  SetRowNull = () => {
    var col = this.state.tableData;
    var NewCol = [];
    var j = 0;
    for (var i = 0; i < col.length; i++) {
      if (col[i].EXPCODE) {
        NewCol[j] = col[i];
        NewCol[j].C0 = j + 1;
        j++;
      }
    }
    for (var i = j; i < col.length; i++) {
      NewCol[j] = { C0: j + 1 };
      j++;
    }
    this.setState({ tableData: NewCol })
  };
  AddDataRow = () => {
    var j = 0;
    for (var i = 0; i <= rowTable - 1; i++) {
      var data = this.state.tableData;
      if (this.state.tableData[i].EXPCODE !== "") {
        data[j] = {
          C0: j + 1,
          EXPCODE: this.state.tableData[i].EXPCODE,
          EXPNAME: this.state.tableData[i].EXPNAME,
          REMARK: this.state.tableData[i].REMARK,
          AMOUNT: this.state.tableData[i].AMOUNT,
          DEPARTMENT_TH: this.state.tableData[i].DEPARTMENT_TH,
          SITECODE_TH: this.state.tableData[i].SITECODE_TH,
          BTN_T: this.state.tableData[i].BTN_T,
          C9: this.state.tableData[i].C9,
          C10: this.state.tableData[i].C10,
          DEPARTMENT: this.state.tableData[i].DEPARTMENT,
          SITECODE: this.state.tableData[i].SITECODE,
          SB: this.state.tableData[i].SB
        };
        j++;
      }
    }
    for (var i = j; i <= rowTable - 1; i++) {
      var data = this.state.tableData;
      data[i] = {
        C0: i + 1,
        EXPCODE: "",
        EXPNAME: "",
        REMARK: "",
        AMOUNT: "",
        DEPARTMENT_TH: "",
        SITECODE_TH: "",
        BTN_T: "",
        C9: "",
        C10: "",
        DEPARTMENT: "",
        SITECODE: "",
        SB: "0"
      };
    }
    this.setState({ tableData: data });
    this.Cal_Price();
  };
  Chkinputtax = async () => {
    console.log(this.state.inputtax);
    let inputtax = []
    var data = []
    var beforetax = 0
    if (this.state.inputtax.length > 0) {
      for (var i = 0; i < this.state.inputtax.length && this.state.inputtax[i].Invoicedate; i++) {
        beforetax += Number(this.state.inputtax[i].Amountbeforetax)
        data[i] = {
          Taxinvoice: this.state.inputtax[i].Taxinvoice,
          Invoicedate: (Moment(this.state.inputtax[i].Invoicedate, 'DD/MM/YYYY').add(-543, 'year').format('YYYY-MM-DD')),
          PayableCode: this.state.inputtax[i].PayableCode,
          PayableName: this.state.inputtax[i].PayableName,
          Taxdescription: this.state.inputtax[i].Taxdescription,
          Amountbeforetax: this.state.inputtax[i].Amountbeforetax,
          Tax: this.state.inputtax[i].Tax,
          Taxincluded: this.state.inputtax[i].Taxincluded,
          Refundablerate: this.state.inputtax[i].Refundablerate,
          Refundablevalue: this.state.inputtax[i].Refundablevalue,
          Refundabletax: this.state.inputtax[i].Refundabletax
        }
        inputtax.push(data[i]);
      }
    }
    this.setState({ beforetax: beforetax })
    return await inputtax
  }
  saveData = async () => {
    const parameter = new URLSearchParams();
    const parameter2 = new URLSearchParams();
    var dataTT = [];
    var s = [];
    for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].EXPCODE; i++) {
      dataTT[i] = {
        Expcode: this.state.tableData[i].EXPCODE,
        Expname: this.state.tableData[i].EXPNAME,
        Remark: this.state.tableData[i].REMARK,
        Amount: this.state.tableData[i].AMOUNT,
        Department: this.state.tableData[i].DEPARTMENT,
        Sitecode: this.state.tableData[i].SITECODE,
        Btn_T: this.state.tableData[i].BTN_T,
        Extamount: this.state.tableData[i].EXTAMOUNT,
        Extbathamount: this.state.tableData[i].EXTBATHAMOUNT,
        Wtaxamount: this.state.tableData[i].WTAXRATE,
        Paybalance: this.state.tableData[i].PAYBALANCE,
        Projectcode: (this.state.tableData[i].PROJECT ? this.state.tableData[i].PROJECT : "")
      }
      s.push(dataTT[i]);
    }
    parameter.append("listitem", JSON.stringify(s));
    let datainputtax = []
    await this.Chkinputtax().then((result) => {
      datainputtax = result
    })
    parameter.append("muntitaxinput", JSON.stringify(datainputtax))
    parameter.append("CREATEUSER", localStorage.getItem("Username"));
    parameter.append("UPDATEUSER", localStorage.getItem("Username"));
    parameter.append("OWNERCODE", localStorage.getItem("Username"));
    parameter.append("USERCODE", localStorage.getItem("Username"));
    parameter.append("APNAME", this.APNAME.current.value);
    parameter.append("APCODE", this.APCODE.current.value);
    parameter.append("DOCGROUP", this.Groupdata_code.current.value);
    parameter.append("DOCDATE", this.state.DOCDATE);
    parameter.append("DOCNO", this.DOCNO.current.value);
    parameter.append("CREDITCODE", this.state.Creditcode);
    parameter.append("REMARK", this.REMARK.current.value);
    parameter.append("TAXTYPE", this.state.TAXTYPE);
    parameter.append("CALCWTAX", this.state.CALCWTAX);
    parameter.append("DEPARTMENT", this.DEPARTMENT.current.value);
    parameter.append("SITECODE", this.SITECODE.current.value);
    parameter.append("CURRENCYCODE", "TH");
    parameter.append("SUMAMOUNT1", this.SUMAMOUNT1.current.value);
    parameter.append("TAXRATE", typeof this.TAXRATE.current.value ? this.TAXRATE.current.value : 0);
    parameter.append("TAXAMOUNT", this.TAXAMOUNT.current.value);
    parameter.append("TOTALAMOUNT", this.TOTALAMOUNT.current.value);
    parameter.append("SUMAMOUNT2", this.SUMAMOUNT2.current.value);
    parameter.append("DEBTAMOUNT", this.DEBTAMOUNT.current.value);
    parameter.append("BATHSUMAMOUNT1", Number(this.TOTALAMOUNT.current.value - this.TAXAMOUNT.current.value));
    parameter.append("BATHSUMAMOUNT2", this.SUMAMOUNT2.current.value);
    parameter.append("DUEDATE", this.state.DUEDATE);
    parameter.append("COMPNAME", "")
    parameter.append("PROJECT", this.state.PROJECT)
    var Uststus = true;
    for (var pair of parameter.entries()) {
      console.log(pair);
    }
    if (Uststus === true) {
      this.setState({ openBackdrop: true })
      var url = "CSAPOTHERDEBT/Save?user=";
      // await axios.post(genpostURLTEST("/Save?user="), parameter).then(async res => {
      await axios.post(genpostURL(url), parameter).then(async res => {
        if (res.data.status === "success") {
          parameter2.append("COMPNAME", window.location.hostname);
          parameter2.append("DOCNO", this.DOCNO.current.value);
          parameter2.append("TABLENAME", "CSAPOTHERDEBT");
          parameter2.append("SaleMan", localStorage.getItem("Username"));
          parameter2.append("MAKETYPE", "พิมพ์เอกสาร");
          parameter2.append("MAKEREM", "PSMT-ใบรับเงินมัดจำ.xml");
          parameter2.append("MAKEFALG", "3");
          this.setState({ opensnackbar: true })
          this.setState({ color: "success" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "บันทึกสำเร็จ" })
          setTimeout(() => {
            //    this.ResetThisPage();
            this.setState({ openBackdrop: false })
          }, 30);
        } else {
          this.setState({ opensnackbar: true })
          this.setState({ color: "warning" })
          this.setState({ icon: ErrorIcon })
          this.setState({ messagealert: "บันทึกไม่สำเร็จ" + res.data.status })
          this.setState({ openBackdrop: false })
        }
      }).catch(error => {
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
        this.setState({ openBackdrop: false })
      });
      setTimeout(() => {
        this.setState({ openFullScreenDialogs: false })
      }, 1500);
    }
  };
  ResetThisPage() {
    window.location.replace("/PSApotherdebt");
  }

  Switch_PopUpSaveMoney = e => {
    this.setState({ openFullScreenDialogs: false })
  };
  _saveConnection = () => {
    var table = this.state.tableData
    var BTN_T = "0"
    // if (table.length === 0) {
    //   this.setState({ opensnackbar: true })
    //   this.setState({ color: "warning" })
    //   this.setState({ icon: ErrorIcon })
    //   this.setState({ messagealert: "กรุณาเพิ่มรายการรับเงินล่วงหน้า/เงินมัดจำ" })
    //   return
    // }
    var checkbtn = false

    for (var i = 0; i < table.length; i++) {
      if (table[i].BTN_T === "1") {
        checkbtn = true
      }
    }
    var Totaltax = 0
    for (let i = 0; i < this.state.inputtax.length; i++) {
      if (this.state.inputtax[i].Taxinvoice) {
        Totaltax += Number(this.state.inputtax[i].Tax)
      }
    }
    if (this.state.TAXTYPE === "0") {
      if (checkbtn === true && Totaltax === 0 && Number(this.TAXRATE.current.value) > 0) {
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "ให้กำหนดรายการภาษีมูลค่าเพิ่มก่อน ...!" })
        return
      }
    }
    if (this.state.TAXTYPE === "1") {
      if (checkbtn === false || Totaltax === 0 || Number(this.TAXRATE.current.value) === 0) {
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "ให้ใส่ภาษีมูลค่าเพิ่มก่อน ...!" })
        return
      }
    }

    for (var i = 0; i < table.length; i++) {
      if (table[0].EXPCODE) {
        if (table[i].EXPCODE) {
          if (table[i].BTN_T === "1") {
            BTN_T = "1"
          }
          if (Number(table[i].AMOUNT) === 0) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "จำนวนเงินต้องไม่เท่ากับ 0 ...!" })
            return
          }
          if (!table[i].DEPARTMENT) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกแผนก...!" })
            return
          }
          if (!table[i].SITECODE) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกสาขา...!" })
            return
          }
          if (table[i].DEPARTMENT !== this.DEPARTMENT.current.value) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "แผนกไม่ตรงกันกรุณาตรวจสอบ...!" })
            return
          }
        }
      } else {
        this.setState({ opensnackbar: true })
        this.setState({ color: "warning" })
        this.setState({ icon: ErrorIcon })
        this.setState({ messagealert: "กรุณาเพิ่มรายการรับเงินล่วงหน้า/เงินมัดจำ" })
        return
      }
    }


    if (this.APCODE.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" })
      this.APCODE.current.focus();
      return;
    }
    if (this.Groupdata_code.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกกลุ่มข้อมูล" })

      this.DOCGROUP.current.focus()
      return;
    }
    if (this.state.SiteCode_code === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกสาขา" })

      this.Branch.current.focus()
      return;
    }
    if (this.DEPARTMENT.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกแผนก" })
      this.DEPARTMENTTH.current.focus()
      return;
    }
    if (Number(this.DEBTAMOUNT.current.value) <= 0) {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "ให้ใส่จำนวนเงินก่อน" })
      return;
    } else {
      this.saveData()
    }

  };
  convertimeps = (date) => {
    if (date) {
      var myDate = new Date(date);
      var date = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
      var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
      var year = myDate.getFullYear() + 543;
      return date + "/" + month + "/" + year;
    } else {
      return "";
    }
  }
  _reCHK = async (RowData) => {

    this.setState({ openBackdrop: true })
    this.CloseDialogs(false)
    console.log("logdata", RowData);

    let url = "CSAPOTHERDEBT/CSAPOTHERDEBT?Docno=" + RowData[0].docNo;
    console.log("url_reCHK", genURL(url));
    await axios.get(genURL(url), { timeout: 3600 }).then(res => {
      if (res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          //บันทึกใบกำกับภาษีหลายใบ
          this.checkCsinputtax(res.data[i].DOCNO, res.data[i].TAXAMOUNT)
          this.APCODE.current.value = res.data[i].APCODE;
          this.APNAME.current.value = res.data[i].APNAME;
          this.DOCNO.current.value = res.data[i].DOCNO;
          this.REMARK.current.value = res.data[i].REMARK;
          this.setState({ DOCDATE: Moment(res.data[i].DOCDATE, 'YYYY-MM-DD').add(543, "year").format('DD/MM/YYYY') })
          this.setState({ DUEDATE: Moment(res.data[i].DUEDATE, 'YYYY-MM-DD').add(543, "year").format('DD/MM/YYYY') })
          this.setState({ Creditcode: res.data[i].CREDITCODE })
          this.setState({ TAXTYPE: res.data[i].TAXTYPE })
          this.setState({ CALCWTAX: res.data[i].CALCWTAX })
          this.setState({ PROJECT: res.data[i].PROJECT })
          this.SUMAMOUNT1.current.value = res.data[i].SUMAMOUNT1;
          this.TAXRATE.current.value = res.data[i].TAXRATE;
          this.TAXAMOUNT.current.value = res.data[i].TAXAMOUNT;
          this.TOTALAMOUNT.current.value = res.data[i].TOTALAMOUNT;
          this.SUMAMOUNT2.current.value = res.data[i].SUMAMOUNT2;
          this.DEBTAMOUNT.current.value = res.data[i].DEBTAMOUNT;

          this.onAddValue("DOCGROUP", res.data[i].DOCGROUP, "Y");
          this.onAddValue("Department", res.data[i].DEPARTMENT);
          this.onAddValue("Branch", res.data[i].SITECODE);

        }
      }
    }).catch(error => {
      console.log(error);
    });
    var arrData = this.state.tableData;
    var url1 = "CSAPOTHERDEBT/CSAPOTHERDEBTSUB?Docno=" + RowData[0].docNo;
    console.log(genURL(url1));
    await axios.get(genURL(url1), { timeout: 3600 }).then(async (res) => {
      if (res.data.length > 0) {
        for (var i = 0; i < res.data.length; i++) {
          let DEPARTMENT = "", DEPARTMENT_TH = ""
          await CheckDepartmentname(res.data[i].DEPARTMENT).then(async (result) => {
            if (result !== "") {
              DEPARTMENT = res.data[i].DEPARTMENT
              DEPARTMENT_TH = await result
            }
          })
          let SITECODE = "", SITECODE_TH = ""
          await CheckBrabchname(res.data[i].SITECODE).then(async (result) => {
            if (result !== "") {
              SITECODE = res.data[i].SITECODE
              SITECODE_TH = await result
            }
          })
          arrData[i] = {
            C0: i + 1,
            EXPCODE: res.data[i].EXPCODE,
            EXPNAME: res.data[i].EXPNAME,
            REMARK: res.data[i].REMARK,
            AMOUNT: res.data[i].AMOUNT,
            DEPARTMENT_TH: DEPARTMENT_TH,
            DEPARTMENT: DEPARTMENT,
            SITECODE_TH: SITECODE_TH,
            SITECODE: SITECODE,
            BTN_T: String(res.data[i].CALCTAX),
            EXTAMOUNT: res.data[i].EXTAMOUNT,
            PROJECT: res.data[i].PROJECT,
            EXTBATHAMOUNT: res.data[i].EXTBATHAMOUNT,
            WTAXRATE: res.data[i].WTAXRATE,
            PAYBALANCE: res.data[i].PAYBALANCE,
          }
        }
      }
    }).catch(error => {
      console.log(error);
    });
    await this.setState({ tableData: arrData });
    await this.setState({ openBackdrop: false })

  };
  checkCsinputtax = (docNo, TAXAMOUNT) => {
    var sinputtax = []
    let url = "CSINPUTTAX/Search?Tablename=CSAPOTHERDEBT&Docno=" + docNo
    console.log(genURL(url));
    axios.post(genURL(url)).then(async res => {
      if (res.data.length > 0) {
        for (let i = 0; i < res.data.length + 25; i++) {
          if (i < res.data.length) {
            sinputtax[i] = await {
              // numrow: i + 1,
              Taxinvoice: res.data[i].TAXNO,
              Invoicedate: res.data[i].PRINTDATE,
              PayableCode: res.data[i].APCODE,
              PayableName: res.data[i].APNAME,
              Taxdescription: res.data[i].REMARK,
              Amountbeforetax: res.data[i].BEFORETAX,
              Tax: res.data[i].TAXAMOUNT,
              Taxincluded: res.data[i].TOTALAMOUNT,
              B_TAXRATE: res.data[i].B_TAXRATE,
              B_AMOUNT: res.data[i].B_AMOUNT,
              B_TAXAMOUNT: res.data[i].B_TAXAMOUNT,
            }
          } else {
            sinputtax[i] = await {
              // numrow: i + 1,
              Taxinvoice: "",
              Invoicedate: "",
              PayableCode: "",
              PayableName: "",
              Taxdescription: "",
              Amountbeforetax: "",
              Tax: "",
              Taxincluded: "",
            }
          }
        }

      }
    })
    this.setState({ inputtax: sinputtax })
    this.setState({ Refundablerate: 0 })
    this.setState({ Refundablevalue: 0 })
    this.setState({ Taxrefund: 0 })
    this.setState({ Totaltax: TAXAMOUNT })
  }
  ResetDocSent = () => {
    window.location.reload();
  }
  _printReport = () => {
    if (this.DOCNO.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกเลขที่เอกสาร" })

      return;
    } else {
      this._callForm(this.DOCNO.current.value);
    }
  };
  _callForm = vel => {
    let url1 =
      "https://csrpt.pspl.co.th/jasperserver/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FARDEPOSIT&standAlone=true&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u&j_username=rpt&j_password=042615116&output=pdf&docno=" +
      vel;
    this.setState({ urlsend: url1 });
    setTimeout(() => {
      this.switchshowform();
    }, 100);
  };

  switchshowform = e => {
    this.setState({ showform: !this.state.showform });
  };

  onSearch = (e) => {
    var data = this.state.tableData
    for (var i = 0; i < data.length; i++) {
      data[i].EXPCODE = "";
      data[i].EXPNAME = "";
      data[i].REMARK = "";
      data[i].AMOUNT = "";
      data[i].DEPARTMENT_TH = "";
      data[i].C5_insert = "";
      data[i].SITECODE_TH = "";
      data[i].BTN_T = "";
      data[i].C9 = "";
      data[i].discount = "";
      data[i].C10 = "";
      this.setState({ tableData: data });
      let arrforparm = []
      this.setState({ openFullScreenDialogs: true })
      this.setState({ typeFullScreenDialogs: "SwitchSearchDoc" })
      this.setState({ titleFullScreenDialogs: "บันทึกตั้งเจ้าหนี้" })
      this.setState({ dataforpopup: arrforparm })
    }
  }

  onAddValue = async (type, value, Fix) => {
    if (value) {
      switch (type) {
        case "DOCGROUP":
          var url = "CSDOCGROUP/Code?code=" + value + "&tablename=CSAPOTHERDEBT"
          url = "CSDOCGROUP/Searchbycode?tablename=CSAPOTHERDEBT&txt=" + value + "&Usercode=" + localStorage.getItem("Username") + "&top=300"
          console.log(genURL(url));
          axios.get(genURL(url), { timeout: 3600 }).then(async (res) => {
            if (res.data.length > 0) {
              this.Groupdata_code.current.value = res.data[0].CODE
              this.DOCGROUP.current.value = res.data[0].MYNAMETH
              this.setState({ Groupdata_txt: res.data[0].MYNAMETH });
              if (Fix !== "Y") {
                await Chackdocno(value, "CSAPOTHERDEBT").then((result1) => {
                  if (result1 !== "") {
                    this.DOCNO.current.value = result1
                  } else {
                    this.DOCNO.current.value = ""
                  }
                }).catch((err) => {
                  this.DOCNO.current.value = ""
                  console.log(err);
                });
              }
            } else {
              this.setState({ opensnackbar: true })
              this.setState({ color: "warning" })
              this.setState({ icon: ErrorIcon })
              this.setState({ messagealert: "ไม่พบข้อมูล" })
              this.Groupdata_code.current.value = ""
              this.DOCGROUP.current.value = ""
              this.setState({ Groupdata_txt: "" });
              this.DOCNO.current.value = ""
            }
          }).finally(_ => {
            CheckTaxrate(value, "CSAPOTHERDEBT").then((result) => {
              if (Fix !== "Y") {
                this.TAXRATE.current.value = result
              }
            })
          }).catch((err) => {
            this.Groupdata_code.current.value = ""
            this.DOCGROUP.current.value = ""
            this.setState({ Groupdata_txt: "" });
            this.DOCNO.current.value = ""
            console.log(err);
          });
          break;
        case "APCODE":
          await ChackAp(value).then((result) => {
            if (result !== "") {
              let data = result.split("|")
              this.APCODE.current.value = value
              this.APNAME.current.value = data[0]
              this.setState({ TAXTYPE: data[2] })
              this.setState({ Creditcode: [data[1]] })
              this.setState({ CALCWTAX: ["0"] })
            } else {
              this.setState({ opensnackbar: true })
              this.setState({ color: "warning" })
              this.setState({ icon: ErrorIcon })
              this.setState({ messagealert: "ไม่พบข้อมูล" })
              this.APCODE.current.value = ""
              this.APNAME.current.value = ""
            }
          }).catch((err) => {
            this.APCODE.current.value = ""
            this.APNAME.current.value = ""
            console.log(err);
          });
          break;
        case "USERCODE":
          await CheckUser(value).then(async (result) => {
            if (result !== "") {
              this.USERCODE.current.value = await value
              this.USERNAME.current.value = await result
            } else {
              this.setState({ opensnackbar: true })
              this.setState({ color: "warning" })
              this.setState({ icon: ErrorIcon })
              this.setState({ messagealert: "ไม่พบข้อมูล" })
              this.USERCODE.current.value = ""
              this.USERNAME.current.value = ""
            }
          }).catch((err) => {
            this.USERCODE.current.value = ""
            this.USERNAME.current.value = ""
            console.log(err);
          });
          break;
        case "Department":
          await CheckDepartmentname(value).then((result) => {
            if (result !== "") {
              this.DEPARTMENT.current.value = value
              this.DEPARTMENTTH.current.value = result
              this.setState({ Department_txt: result });
            } else {
              this.setState({ opensnackbar: true })
              this.setState({ color: "warning" })
              this.setState({ icon: ErrorIcon })
              this.setState({ messagealert: "ไม่พบข้อมูล" })
              this.DEPARTMENT.current.value = ""
              this.DEPARTMENTTH.current.value = ""
              this.setState({ Department_txt: "" });
            }
          }).catch((err) => {
            this.DEPARTMENT.current.value = ""
            this.DEPARTMENTTH.current.value = ""
            this.setState({ Department_txt: "" });
            console.log(err);
          });
          break;
        case "Branch":
          await CheckBrabchname(value).then((result) => {
            if (result !== "") {
              this.SITECODE.current.value = value
              this.Branch.current.value = result
              this.setState({ Branch_txt: result });
            } else {
              this.setState({ opensnackbar: true })
              this.setState({ color: "warning" })
              this.setState({ icon: ErrorIcon })
              this.setState({ messagealert: "ไม่พบข้อมูล" })
              this.SITECODE.current.value = ""
              this.Branch.current.value = ""
              this.setState({ Branch_txt: "" });
            }
          }).catch((err) => {
            this.SITECODE.current.value = ""
            this.Branch.current.value = ""
            this.setState({ Branch_txt: "" });
            console.log(err);
          });
          break;
        default: break;
      }
    }
  };

  Chackdoc = () => {
    Chackdocno(this.Groupdata_code.current.value, "CSAPOTHERDEBT").then(async (result1) => {
      if (result1 !== undefined) {
        this.DOCNO.current.value = await result1
      } else {
        this.DOCNO.current.value = ""
      }
    }).catch((err) => {
      this.DOCNO.current.value = ""
      console.log(err);
    });
  }
  onClick = (e) => {
    if (e.target.value !== "") {
      switch (e.target.name) {
        case "DOCGROUP":
          this.DOCGROUP.current.value = this.Groupdata_code.current.value
          break;
        case "DEPARTMENTTH":
          this.DEPARTMENTTH.current.value = this.DEPARTMENT.current.value
          break;
        case "Branch":
          this.Branch.current.value = this.SITECODE.current.value
          break;
        default:
          break;
      }
    }
  }
  onKeyDown = (e) => {
    if (e.key === "Enter") {
      if (e.target.name === "DOCGROUP") {
        this.onAddValue("DOCGROUP", e.target.value);
      }
      if (e.target.name === "APCODE") {
        this.onAddValue("APCODE", e.target.value);
      }
      if (e.target.name === "DEPARTMENTTH") {
        this.onAddValue("Department", e.target.value);
      }
      if (e.target.name === "Branch") {
        this.onAddValue("Branch", e.target.value);
      }
    }
  };
  onChange = (e) => {
    switch (e.target.name) {
      case 'DOCGROUP':
        if (e.target.value === "") {
          this.setState({ Groupdata_txt: "" })
          this.Groupdata_code.current.value = "";
          this.DOCNO.current.value = "";
        }
        break;
      case 'APCODE':
        if (e.target.value === "") {
          this.APCODE.current.value = "";
          this.APNAME.current.value = "";
        }
        break;
      case 'DEPARTMENTTH':
        if (e.target.value === "") {
          this.setState({ Department_txt: "" })
        }
        break;
      case 'Branch':
        if (e.target.value === "") {
          this.setState({ Branch_txt: "" })
          this.SITECODE.current.value = ""
        }
        break;
      default:
        break;
    }
  }
  onBlur = (e) => {
    if (e.target.name === "DOCGROUP") {
      this.DOCGROUP.current.value = this.state.Groupdata_txt;
    }
    if (e.target.name === "DEPARTMENTTH") {
      this.DEPARTMENTTH.current.value = this.state.Department_txt;
    }
    if (e.target.name === "Branch") {
      this.Branch.current.value = this.state.Branch_txt;
    }
  };
  ReturnData = (e) => {



    if (this.state.selectpopup === "Inputtax") {
      this.setState({ openFullScreenDialogs: e[0] })

      if (e !== "") {
        this.setState({ inputtax: e[1] })
        this.setState({ Refundablerate: e[2] })
        this.setState({ Refundablevalue: e[3] })
        this.setState({ Taxrefund: e[4] })
        this.setState({ Totaltax: e[5] })
      } else {
        this.setState({ inputtax: this.state.inputtax })
        this.setState({ Refundablerate: this.state.Refundablerate })
        this.setState({ Refundablevalue: this.state.Refundablevalue })
        this.setState({ Taxrefund: this.state.Taxrefund })
        this.setState({ Totaltax: this.state.Totaltax })
      }
    }
  }
  openDialog = (e) => {
    this.setState({ selectpopup: e })
    if (this.state.DOCDATE === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกวันที่ก่อน ...!" })
      return
    }
    if (this.APCODE.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
      return
    }
    if (this.APNAME.current.value === "") {
      this.setState({ opensnackbar: true })
      this.setState({ color: "warning" })
      this.setState({ icon: ErrorIcon })
      this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
      return
    }
    if (e === "Inputtax") {
      let arrforparm = []
      arrforparm.push(this.state.DOCDATE)
      arrforparm.push(this.APCODE.current.value)
      arrforparm.push(this.APNAME.current.value)
      arrforparm.push(7)
      // ข้อมูลในตาราง
      arrforparm.push(this.state.inputtax)
      //  อัตราขอคืนได้
      arrforparm.push(this.state.Refundablerate)
      // มูลค่าที่ขอคืนได้
      arrforparm.push(this.state.Refundablevalue)
      // ภาษีที่ขอคืนได้
      arrforparm.push(this.state.Taxrefund)
      // รวมยอดภาษี
      arrforparm.push(this.state.Totaltax)
      // this.setState({ parm: arrforparm })

      this.setState({ openFullScreenDialogs: true })
      this.setState({ typeFullScreenDialogs: e })
      this.setState({ titleFullScreenDialogs: "เลือกใบเตรียมจ่ายชำระหนี้-Prepayment" })
      this.setState({ dataforpopup: arrforparm })
    }
  }

  _pricetype = async (Texttype) => {
    let strTexttype = String(Texttype)
    this.setState({ TAXTYPE: [strTexttype] })
    this.Cal_Price();
  };
  onClickTopbar = (e) => {
    switch (e) {
      case "save":
        this._saveConnection()
        break;
      case "new":
        this.ResetDocSent()
        break;
      case "print":
        this._printReport(null)
        break;
      case "search":
        this.onSearch();
        break;
      case "Inputtax":
        this.openDialog(e)
        break;
      default:
        break;
    }
  }
  CloseDialogs = () => {
    this.setState({ openFullScreenDialogs: false })
  }
  SELECTPROJECT = (cell, row, enumObject, rowIndex) => {
    var btnShow = "";
    if (row.EXPCODE) {
      btnShow = (
        <div>
          <SelectDatas
            origin="PROJECT"  // ประเภท
            valueSelect={e => this.SelectSetData("PROJECT", e, String(rowIndex))} // รับค่ากลับ
            title="-"
            defaultselect={row.PROJECT}// ค่าเริ่มต้นของ ประเภทราคา
            opentitle={true}
          />
        </div >
      )
    }
    return <div>{btnShow}</div>;
  };
  render() {
    const cellEditProp = {
      mode: "click",
      blurToSave: true,
      afterSaveCell: this.afterSaveCell,
      blurToSave: true,
    };
    const options = {
      onRowClick: this.onRowClick,
      onMouseLeave: this.onMouseLeave,
      insertBtn: this.createCustomInsertButton
    };
    const type = this.state.typeFullScreenDialogs
    return (
      <div className="PSApp" onClick={this.onClick} onKeyDown={this.onKeyDown} onChange={this.onChange} onBlur={this.onBlur}>
        <Backdrop open={this.state.openBackdrop} />
        <FullScreenDialogs
          open={this.state.openFullScreenDialogs}
          title={this.state.titleFullScreenDialogs}
          closeDialog={e => this.CloseDialogs(e)}>
          {type === "Inputtax" ? <Inputtax parm={this.state.dataforpopup} resdata={e => this.ReturnData(e)} /> : null}
          {type === "SwitchPopupArcode" ? <PopupArcode closePopup={e => this.CloseDialogs(e)} Get_PopupApcode={this.Get_PopUparcode} /> : null}
          {type === "Groupdataall" || type === "Department" || type === "Branch" ? (<PopUpOther closePopup={e => this.CloseDialogs(e)} type={this.state.OtPopupType} Get_PopUpOther={this.Get_PopUpOther} userSite={this.state.siteCodeUser} from="CSAPOTHERDEBT" />) : null}
          {type === "showPopupOT" ? (<PopUpCsexpense GetPopUpCsexpense={this.GetPopUpCsexpense} type={this.state.PopUpTYpe} from="CSAPOTHERDEBT" />) : null}
          {type === "SwitchSearchDoc" ?
            <Rechecked Dataselect={e => this._reCHK(e)} from="CSAPOTHERDEBT" />
            // <_popuplistreport resdata={this._reCHK} from="CSAPOTHERDEBT" />
            : null}
          {type === "Departmenttb" || type === "Branchtb" ? <PopUpOtherDB closePopup={e => this.CloseDialogs(e)} Get_PopUpOther={this.Get_PopUpDB} type={this.state.PopUpTYpe} userSite={this.state.siteCodeUser} from="CSAPOTHERDEBT" /> : null}
        </FullScreenDialogs>
        {this.state.showform ? (<PopUpReport close={this.switchshowform} url={this.state.urlsend} />) : null}
        <div className="displaymain">
          <Topbar
            listmenu={listmenu}
            title="บันทึกตั้งเจ้าหนี้อื่นๆ"
            onClick={e => this.onClickTopbar(e)}
          />
          <div className="PSAppfrom">
            <Grid>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Row className="show-grid">
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <Row className="show-grid">
                      <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon"> รหัสเจ้าหนี้ </span>
                          <input id="APCODE" type="text" className="form-control " name="APCODE" ref={this.APCODE} />
                          <span className="input-group-addon icon" onClick={this.Switch_PopupArcode.bind(null)}>
                            <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                          </span>
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={8} md={8} lg={8}>
                    <Row className="show-grid">
                      <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon icon">  <i className="fas fa-user"></i></span>
                          <input id="APNAME" type="text" className="form-control " ref={this.APNAME} name="APNAME" readOnly />
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <Row className="show-grid">
                      <MaterialUIPickers title="วันที่เอกสาร"
                        DateValue={e => this.SelectSetData("Calendar1", e)}
                        defaultdate={this.state.DOCDATE}
                        open={this.state.checkenableInput['DOCDATE']}
                      // open={this.state.checkenableInput.DocDate}
                      />
                    </Row>
                  </Col>
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <Row className="show-grid">
                      <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon"> กลุ่มข้อมูล  </span>
                          <input type="hidden" ref={this.Groupdata_code} />
                          <input id="DOCGROUP" type="text" className="form-control " name="DOCGROUP" ref={this.DOCGROUP} />
                          <span id="DOCGROUP" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Groupdataall")}>
                            <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                          </span>
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <Row className="show-grid">
                      <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon"> เลขที่เอกสาร  </span>
                          <input id="DOCNO" type="text" className="form-control " name="DOCNO" ref={this.DOCNO} disabled />
                          <span id="iconTaxNumber" className="input-group-addon icon">
                            <i className="fas fa-sync-alt" onClick={() => this.Chackdoc()}></i>
                          </span>
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={8} md={8} lg={8}>
                    <Row className="show-grid">
                      <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon"> หมายเหตุ  </span>
                          <input id="REMARK" type="text" className="form-control " name="REMARK" ref={this.REMARK} />
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <Row className="show-grid">
                      <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <SelectDatas
                            origin="PriceType"  // ประเภท
                            valueSelect={e => this.SelectSetData("PriceType", e)} // รับค่ากลับ
                            title="ประเภทราคา"
                            defaultselect={this.state.TAXTYPE}// ค่าเริ่มต้นของ ประเภทราคา
                          />
                        </div>
                      </div>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Grid>
          </div>
          <div className="container-fluid">
            <div className="PSAppTable">
              <BootstrapTable
                data={this.state.tableData}
                cellEdit={cellEditProp}
                options={options}
                trClassName="trClassName"
                tableHeaderClass="trClassName"
                height="400"
              >
                <TableHeaderColumn row="0" rowSpan="2" dataField='C0' isKey width="35" dataAlign="center" ></TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" headerAlign='center' className="colbuttomhidden" width="120">รหัส</TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="EXPCODE" width="90" editable={this.state.Colcode} dataAlign="left"></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="BTN_EXPCODE" width="30" editable={false} dataAlign="left" dataFormat={this._cellButton.bind(this)} columnClassName="columnClassNameFormat1" /* hidden={this.state.C1_hiden} */></TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" dataAlign="left" dataField="EXPNAME" width="140" editable={this.state.Colall}> รายการ </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" dataAlign="left" dataField="REMARK" width="140" editable={this.state.Colall}>  อธิบายเพิ่มเติม</TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" dataAlign="reight" dataField="AMOUNT" width="100" editable={this.state.Colall}>  จำนวนเงิน</TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" dataAlign="center" className="colbuttomhidden" >  แผนก</TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="DEPARTMENT_TH" width="80" editable={this.state.Colall} dataAlign="left"></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="BTN_Department" width="30" editable={false} dataAlign="left" dataFormat={this._cellButton2.bind(this)} columnClassName="columnClassNameFormat1" hidden={this.state.C5_hiden}></TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" dataField="PROJECT" editable={false} dataAlign="center" dataFormat={this.SELECTPROJECT.bind(this)} width="150"><div align="center"> โครงการ </div></TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" width="130" dataAlign="center" className="colbuttomhidden" >  สาขา <i id="t_sitecode" style={{ fontSize: "10px" }}></i></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="SITECODE_TH" width="100" editable={this.state.Colall} dataAlign="left"></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="BTN_Sitecode" width="30" editable={false} dataAlign="left" dataFormat={this._cellButton3.bind(this)} columnClassName="columnClassNameFormat1" hidden={this.state.C6_hiden}></TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" dataAlign="center" dataField="BTN_T" width="40" editable={false} dataFormat={this.cellcheckbok.bind(this)}> T</TableHeaderColumn>

                <TableHeaderColumn row="1" dataAlign="left" width="100" dataField="DEPARTMENT" hidden >DEPARTMENT</TableHeaderColumn>
                <TableHeaderColumn row="1" dataAlign="left" width="100" dataField="SITECODE" hidden>SITECODE</TableHeaderColumn>
                <TableHeaderColumn row="1" dataAlign="left" width="100" dataField="EXTAMOUNT" hidden >EXTAMOUNT</TableHeaderColumn>
                <TableHeaderColumn row="1" dataAlign="left" width="100" dataField="EXTBATHAMOUNT" hidden >EXTBATHAMOUNT</TableHeaderColumn>
                <TableHeaderColumn row="1" dataAlign="left" width="100" dataField="WTAXRATE" hidden >WTAXRATE</TableHeaderColumn>
                <TableHeaderColumn row="1" dataAlign="left" width="100" dataField="PAYBALANCE" hidden >PAYBALANCE</TableHeaderColumn>
              </BootstrapTable>
            </div>

            <Grid>
              <Col xs={12} sm={8} md={8} lg={8}>
                <Row className="show-grid">
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <Row className="show-grid">
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon"> พนักงาน  </span>
                          <input type="text" className="form-control hidden" ref={this.USERCODE} />
                          <input id="USERNAME" type="text" className="form-control " name="USERNAME" ref={this.USERNAME} readOnly />
                          <span id="iconTaxNumber" className="input-group-addon icon">
                            <i className="fas fa-sync-alt" onClick={() => this.onAddValue("USERCODE", this.state.USERCODE)}></i>
                          </span>
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon"> แผนก  </span>
                          <input type="text" className="form-control hidden" ref={this.DEPARTMENT} />
                          <input id="DEPARTMENTTH" type="text" className="form-control " name="DEPARTMENTTH" ref={this.DEPARTMENTTH} />
                          <span id="CSDEPARTMENT" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Department")}>
                            <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                          </span>
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <SelectDatas
                            origin="PROJECT"  // โครงการ
                            valueSelect={e => this.SelectSetData("PROJECT", e, "")} // รับค่ากลับ
                            title="โครงการ"
                            defaultselect={this.state.PROJECT}// ค่าเริ่มต้นของ โครงการ
                          />
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon"> สาขา  </span>
                          <input type="text" className="form-control hidden" ref={this.SITECODE} />
                          <input id="Branch" type="text" className="form-control " name="Branch" ref={this.Branch} />
                          <span id="Branch" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Branch")}>
                            <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                          </span>
                        </div>
                      </div>
                      <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <SelectDatas
                            origin="CALCWTAX"  // การตั้งหนี้
                            valueSelect={e => this.SelectSetData("CALCWTAX", e)} // รับค่ากลับ
                            title="การตั้งหนี้"
                            defaultselect={this.state.CALCWTAX}// ค่าเริ่มต้นของ การตั้งหนี้
                          />
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <Row className="show-grid">
                      <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <SelectDatas
                            origin="Creditcode"  // รหัสเครดิต
                            valueSelect={e => this.SelectSetData("Creditcode", e)} // รับค่ากลับ
                            title="รหัสเครดิต"
                            defaultselect={this.state.Creditcode}// ค่าเริ่มต้นของ รหัสเครดิต
                          />
                        </div>
                      </div>

                      <MaterialUIPickers title="ครบกำหนด"
                        DateValue={e => this.SelectSetData("Calendar", e)}
                        defaultdate={this.state.DUEDATE} />

                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">สกุลเงิน  </span>
                          <input type="text" className="form-control" value="บาท" readOnly />
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">อัตราแลกเปลี่ยน  </span>
                          <input type="text" className="form-control Price" value="1.0000000" readOnly />
                        </div>
                      </div>
                    </Row>
                  </Col>
                </Row>

              </Col>
              <Col xs={12} sm={4} md={4} lg={4}>
                <Row className="show-grid">
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Row className="show-grid">
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon "> รวมจำนวนเงิน  </span>
                          <input id="SUMAMOUNT1" type="number" className="form-control Price" name="SUMAMOUNT1" ref={this.SUMAMOUNT1} disabled />
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12"  >
                          <span className="input-group-addon "> ภาษีมูลค่าเพิ่ม  </span>
                          <input id="TAXRATE" type="number" className="form-control Price" ref={this.TAXRATE} name="TAXRATE"
                            onClick={(e) => { e.target.value = parseFloat(e.target.value).toFixed(0); }}
                            onKeyDown={this.Cal_Price1} onBlur={this.Cal_Price.bind(null)} />
                          <span className="input-group-addon icon"> % </span>
                          <input id="TAXAMOUNT" type="number" className="form-control Price" ref={this.TAXAMOUNT} name="TAXAMOUNT" value={this.state.TAXAMOUNT} disabled />
                        </div>
                      </div>
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon"> มูลค่ารวมภาษี  </span>
                          <input id="TOTALAMOUNT" type="number" className="form-control Price" name="TOTALAMOUNT" ref={this.TOTALAMOUNT} disabled />
                        </div>
                      </div>
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon  "> มูลค่ายกเว้น  </span>
                          <input id="SUMAMOUNT2" type="number" className="form-control Price" ref={this.SUMAMOUNT2} name="SUMAMOUNT2" value={this.state.SUMAMOUNT2} disabled />
                        </div>
                      </div>
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon  "> เงินรวมทั้งสิ้น  </span>
                          <input id="DEBTAMOUNT" type="number" className="form-control Price" ref={this.DEBTAMOUNT} name="DEBTAMOUNT" value={this.state.DEBTAMOUNT} disabled />
                        </div>
                      </div>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Grid>
            <Snackbar place="br"
              color={this.state.color}
              icon={this.state.icon}
              autoClose={this.state.autoClose}
              message={this.state.messagealert}
              open={this.state.opensnackbar}
              closeNotification={() => { this.setState({ opensnackbar: false }) }}
              close />
          </div >
        </div >
      </div >
    );
  }
}
